<template>
    <footer class="footer">
        <div class="container">
            <div class="footer-content">
                <div class="footer-about">
                    <h3>{{ companyInfo.companyName || '四川庚源电力科技有限公司' }}</h3>
                    <p>{{ companyInfo.introduction ? companyInfo.introduction.substring(0, 100)  : '专注于新能源二次设备安装及调试服务，为客户提供专业的技术解决方案。' }}</p>
                    <div class="footer-social">
                        <a href="#"><i class="fa fa-weixin"></i></a>
                        <a href="#"><i class="fa fa-weibo"></i></a>
                        <a href="#"><i class="fa fa-linkedin"></i></a>
                    </div>
                </div>

                <div class="footer-links">
                    <h3>快速链接</h3>
                    <ul>
                        <li><a href="/">首页</a></li>
                        <li><a href="/about">关于我们</a></li>
                        <li><a href="/services">业务范围</a></li>
                        <li><a href="/cases">成功案例</a></li>
                        <li><a href="/partners">合作伙伴</a></li>
                        <li><a href="/contact">联系我们</a></li>
                    </ul>
                </div>

                <div class="footer-contact">
                    <h3>联系我们</h3>
                    <ul>
                        <li>
                            <i class="fa fa-map-marker"></i>
                            <span>{{ companyInfo.address}}</span>
                        </li>
                        <li>
                            <i class="fa fa-phone"></i>
                            <span>{{ companyInfo.phone }}</span>
                        </li>
                        <li>
                            <i class="fa fa-envelope"></i>
                            <span>{{ companyInfo.email }}</span>
                        </li>
                        <li>
                            <i class="fa fa-clock-o"></i>
                            <span>周一至周五: 9:00 - 18:00</span>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="footer-bottom">
                <p>&copy; {{ new Date().getFullYear() }} {{ companyInfo.companyName || '四川庚源电力科技有限公司' }} 版权所有</p>
                
                <div style="margin-top: 10px;">
                    <a target="_blank" style="color: aliceblue;" href="https://beian.miit.gov.cn/">  蜀ICP备2026008177号</a>
                    <br>
                    <a target="_blank" style="color: aliceblue; display: inline-flex; align-items: center; margin-top: 5px;" href="https://www.beian.gov.cn/">
                        <img src="https://scgy.oss-cn-chengdu.aliyuncs.com/GA.jpg" alt="公安徽章" style="width: 16px; height: 16px; margin-right: 5px;">
                        川公网安备51019002009124号
                    </a>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import { companyApi } from '@/api'

export default {
    name: 'FooterComponent',
    data() {
        return {
            companyInfo: {}
        }
    },
    mounted() {
        this.getCompanyInfo()
    },
    methods: {
        getCompanyInfo() {
            companyApi.getCompanyInfo().then(res => {
                if (res) {
                    this.companyInfo = res.data
                }
            }).catch(err => {
                console.error('获取公司信息失败:', err)
            })
        }
    }
}
</script>

<style scoped>
.footer {
    background-color: #2c3e50;
    color: #fff;
    padding: 60px 0 30px;
}

.container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

.footer-content {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 40px;
    margin-bottom: 40px;
}

.footer-about h3,
.footer-links h3,
.footer-contact h3 {
    font-size: 1.3rem;
    margin-bottom: 20px;
    position: relative;
    padding-bottom: 10px;
}

.footer-about h3::after,
.footer-links h3::after,
.footer-contact h3::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 40px;
    height: 2px;
    background-color: #165DFF;
}

.footer-about p {
    color: #ddd;
    line-height: 1.6;
    margin-bottom: 20px;
}

.footer-social {
    display: flex;
    gap: 15px;
}

.footer-social a {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s;
}

.footer-social a:hover {
    background-color: #165DFF;
}

.footer-links ul {
    list-style: none;
}

.footer-links li {
    margin-bottom: 10px;
}

.footer-links a {
    color: #ddd;
    transition: color 0.3s;
}

.footer-links a:hover {
    color: #165DFF;
    padding-left: 5px;
}

.footer-contact ul {
    list-style: none;
}

.footer-contact li {
    margin-bottom: 15px;
    display: flex;
    align-items: flex-start;
}

.footer-contact i {
    width: 25px;
    color: #165DFF;
    margin-right: 10px;
    flex-shrink: 0;
}

.footer-contact span {
    color: #ddd;
    line-height: 1.6;
}

.footer-bottom {
    text-align: center;
    padding-top: 30px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    color: #aaa;
    font-size: 0.9rem;
}

@media (max-width: 768px) {
    .footer {
        padding: 40px 0 20px;
    }

    .footer-content {
        gap: 30px;
    }
}
</style>